import { useEffect, useState, useRef } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import "./Carousel.css";

const images = [
  process.env.PUBLIC_URL + "/images/image6.jpg",
  process.env.PUBLIC_URL + "/images/image1.jpg",
  process.env.PUBLIC_URL + "/images/image2.jpg",
  process.env.PUBLIC_URL + "/images/image3.jpg",
  process.env.PUBLIC_URL + "/images/image4.jpg",
  process.env.PUBLIC_URL + "/images/image5.jpg",
];


function Carousel() {
  const [index, setIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const trackRef = useRef(null);

  const totalImages = images.length;

  useEffect(() => {
    const timeout = setTimeout(() => {
      goNext();
    }, 30000); // 30 seconds

    const handleKeyDown = (e) => {
      if (e.key === "ArrowRight") goNext();
      else if (e.key === "ArrowLeft") goPrev();
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [index]);

  const goNext = () => {
    setIndex((prev) => prev + 1);
    setIsTransitioning(true);
  };

  const goPrev = () => {
    setIndex((prev) => prev - 1);
    setIsTransitioning(true);
  };

  const handleTransitionEnd = () => {
    // If moving from last real image to the cloned first image
    if (index === totalImages) {
      setIsTransitioning(false);
      setIndex(0);
    }
    // If moving backward from first real image to cloned last image
    if (index === -1) {
      setIsTransitioning(false);
      setIndex(totalImages - 1);
    }
  };

  return (
    <section className="carousel">
      <button className="arrow left" onClick={goPrev}>
        <ChevronLeftIcon className="arrow-icon" />
      </button>

      <div className="carousel-track-container">
        <div
          ref={trackRef}
          className="carousel-track"
          style={{
            transform: `translateX(-${(index + 1) * 100}%)`,
            transition: isTransitioning ? "transform 0.6s ease-in-out" : "none",
          }}
          onTransitionEnd={handleTransitionEnd}
        >
          {/* Clone last image at the start */}
          <img src={images[totalImages - 1]} alt="Clone Last" className="carousel-img" />
          
          {images.map((imgSrc, i) => (
            <img key={i} src={imgSrc} alt={`Slide ${i + 1}`} className="carousel-img" />
          ))}

          {/* Clone first image at the end */}
          <img src={images[0]} alt="Clone First" className="carousel-img" />
        </div>
      </div>

      <button className="arrow right" onClick={goNext}>
        <ChevronRightIcon className="arrow-icon" />
      </button>
    </section>
  );
}

export default Carousel;
